import IntlTelInput from '@intl-tel-input/react';
import 'intl-tel-input/styles';
import {useState} from 'react';
import {parsePhoneNumberFromString} from 'libphonenumber-js/max';
import type {Iso2} from 'intl-tel-input';
import {es as uiTranslations} from 'intl-tel-input/locale';
import {formatPhoneForConfirmation, lookupCountryByIp} from '../../phone.js';

export function PhoneField({error}: {error?: string | undefined}) {
  const [country, setCountry] = useState('');
  const [source, setSource] = useState('auto');
  const [value, setValue] = useState('');
  // "Te llamaremos al +52 81 1234 5678", like the tour form and the calendar: the person sees the number we will use.
  // From phone.js, not the plugin's validity, so normalized Mexican formats ("1 81 …", "044 …") confirm too.
  const confirmation = formatPhoneForConfirmation(value, country);
  const errorId = 'phone-error';
  const hintId = 'phone-hint';
  const describedBy = [hintId, error ? errorId : undefined].filter(Boolean).join(' ');

  return <div className="quiz-field phone-field">
    <label htmlFor="phone">Teléfono</label>
    <IntlTelInput
      initialCountryLookup={async () => await lookupCountryByIp() as Iso2}
      countryNameLocale="es"
      uiTranslations={uiTranslations}
      countrySearch
      countrySelectorMode="AUTO"
      separateDialCode
      formatAsYouType
      numberDisplayFormat="INTERNATIONAL"
      placeholderNumberPolicy="POLITE"
      showFlags
      // No strictMode: it blocked pasted Mexican numbers like "+52 1 81 …", which phone.js normalizes.
      inputProps={{
        id: 'phone',
        name: 'phone',
        autoComplete: 'tel',
        inputMode: 'tel',
        required: true,
        maxLength: 40,
        'aria-invalid': Boolean(error),
        'aria-describedby': describedBy,
        onChange: (event) => {
          const raw = event.currentTarget.value;
          const parsed = parsePhoneNumberFromString(raw, {extract: false});
          if (parsed?.country) {
            setCountry(parsed.country);
            setSource(raw.trim().startsWith('+') ? 'international' : 'manual');
          }
        }
      }}
      loadUtils={() => import('intl-tel-input/utils')}
      onChangeCountry={(iso2) => {
        setCountry(iso2.toUpperCase());
        setSource('manual');
      }}
      onChangeNumber={setValue}
    />
    <input type="hidden" name="country" value={country} />
    <input type="hidden" name="countrySource" value={source} />
    <p id={hintId} className={`field-hint${confirmation ? ' field-hint-success' : ''}`} aria-live="polite">
      {confirmation ? <>Te llamaremos al <strong>{confirmation}</strong></> : 'Elige tu país; el formato se ajusta automáticamente.'}
    </p>
    {error && <p className="quiz-field-error" id={errorId}>{error}</p>}
  </div>;
}
